import { createTranslationRef } from '@backstage/frontend-plugin-api';

const homeReactTranslationRef = createTranslationRef({
  id: "home-react",
  messages: {
    settingsModal: {
      title: "Settings",
      closeButtonTitle: "Close"
    },
    cardExtension: {
      settingsButtonTitle: "Settings"
    }
  }
});

export { homeReactTranslationRef };
//# sourceMappingURL=translation.esm.js.map
